import React from 'react';
import PropTypes from 'prop-types';
import ActionOpenInNew from '@mui/icons-material/OpenInNew';
import IconButton from '@mui/material/IconButton';
import { Tooltip } from '../Tooltip';
import { Reports } from '../../api/relevant';

class ReportAsUrl extends React.Component {
	constructor(props) {
		super(props);
	}

	async openInNewTab() {
		const settings = this.props.getUserAdjustedProperties();
		const url = await Reports.call('getShareUrl', { settings, relative: true });
		window.open(url);
	}

	render() {
		return (
			<Tooltip title="Open in new tab">
				<IconButton
					onClick={(event) => {
						event.preventDefault();
						this.openInNewTab();
					}}
					disableTouchRipple
					size="large"
				>
					<ActionOpenInNew />
				</IconButton>
			</Tooltip>
		);
	}
}

ReportAsUrl.propTypes = {
	getUserAdjustedProperties: PropTypes.func.isRequired,
};

ReportAsUrl.defaultProps = {
	getCurrentProperties: () => {},
};

export default ReportAsUrl;
